<div class="m-content">
  <div class="row">
    <div class="col-lg-12">
      <div class="m-portlet" style="min-height:450px">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="flaticon-map-location"></i>
              </span>
              <h3 class="m-portlet__head-text">
                Refer & Earn
              </h3>

            </div>
          </div>
        </div>
        <div class="m-portlet__body re-page">

          <div class="row">
            <div class="col-lg-8 col-md-7">
              <div class="re-card re-code-card">
                <div class="re-card-label"><i class="la la-gift"></i> Your Referral Code</div>
                <div class="re-code-row">
                  <span class="re-code">{{referralList['code']}}</span>
                  <button class="btn m-btn--pill btn-sm btn-success"
                    (click)="copyMessage(referralList['referralMessage'])" value="click to copy">
                    <i class="la la-copy"></i> Refer And Earn
                  </button>
                </div>
                <div class="re-card-hint">Click "Refer And Earn" to copy the referral message and share it.</div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5">
              <div class="re-card re-credit-card">
                <div class="re-card-label"><i class="la la-star"></i> Available Credits</div>
                <div class="re-credits">{{creditList['credits']}}</div>
              </div>
            </div>

            <!-- <div class="col-md-6">
              <h1 style="font-size:20px;font-weight:800;">Available Credits</h1>
              <h1 style="font-size:26px;margin-right:50px;">{{creditList['credits']}}</h1>
            </div> -->
          </div>

          <div class="re-section">
            <div class="re-section-title"><i class="la la-history"></i> History</div>
            <p-dataTable [value]="history" [rows]="20" [paginator]="true" [pageLinks]="3"
              [rowsPerPageOptions]="[20,30,40]">

              <p-column field="description" header="Description	" [sortable]="true">

              </p-column>
              <p-column field="createdAt" header="Created Date" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.createdAt | date:'dd/MM/yyyy'}}
                </ng-template>
              </p-column>
              <p-column field="creditStatus" header="Credit Status" [sortable]="true">

              </p-column>
              <p-column field="credit" header="Credit" [sortable]="true">

              </p-column>

            </p-dataTable>
          </div>

        </div>

      </div>
    </div>
  </div>


</div>


// WEBPACK FOOTER //
// ./src/app/core/pages/refer-earn/refer-earn.component.html